<template>
  <div class="userCenter" style="overflow: auto;">
    <div class="head">
      <center>
        <!-- <img src="../../../assets/search1.jpg" class="img" /> -->
        <img
          @click="goto('/jnt/center/modify')"
          :src="this.$store.getters.user['headImgUrl']"
          class="img"
        />
      </center>
      <div @click="goto('/jnt/center/modify')" class="nick">
        {{ this.$store.getters.user['nickname'] }}
      </div>
    </div>

    <!-- <div class="navList">
      <ul>
        <li @click="goto('/shop/cart?channel=shop')">
          <i class="iconfont" style="font-size:2.6rem;">&#xe70b;</i><br />购物车
        </li>
        <li @click="goto('/shop/favorites')">
          <i class="iconfont" style="font-size:1.8rem;">&#xe627;</i><br />收藏
        </li>
        <li @click="goto('/shop/mycoupon')">
          <i class="iconfont" style="font-size:2.8rem;">&#xe61f;</i><br />优惠券
        </li>
        <li @click="goto('/jnt/center')">
          <i class="iconfont" style="font-size:2.6rem;">&#xe63a;</i><br />纪念堂
        </li>
      </ul>
    </div> -->
    <div class="contentDiv" style="height: 25.5rem;">
      <div class="menu">
        <ul>
          <li @click="goto('/shop/orders/shop')">
            <i class="iconfont" style="font-size:2.3rem;">&#xe6b3;</i><br />商城购物
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/fuwu/forward')">
            <i class="iconfont" style="font-size:2.4rem;">&#xe60d;</i><br />预约祭扫
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/orders/maintain')">
            <i class="iconfont" style="font-size:2.8rem;">&#xe636;</i><br />缴纳维护费
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/fuwu/tomb')">
            <i class="iconfont" style="font-size:2.6rem;">&#xe66e;</i><br />购墓登记
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/orders/rented')">
            <i class="iconfont" style="font-size:2.8rem;">&#xe637;</i><br />盆花租摆
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/orders/replace')">
            <i class="iconfont" style="font-size:2.8rem;">&#xe76e;</i><br />代客祭扫
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/orders/subscribe')">
            <i class="iconfont" style="font-size:2.8rem;">&#xe634;</i><br />预订服务
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/fuwu/repair')">
            <i class="iconfont" style="font-size:2.8rem;">&#xe624;</i><br />在线报修
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/favorites')">
            <i class="iconfont" style="font-size:2.2rem;">&#xe627;</i><br />我的收藏
          </li>
        </ul>
        <ul>
          <li @click="goto('/shop/mycoupon')">
            <i class="iconfont" style="font-size:2.8rem;">&#xe61f;</i><br />优惠券
          </li>
        </ul>
      </div>
    </div>
    <div class="contentDiv" style="height: 17rem; margin-top:2rem;">
      <div class="menu">
        <ul>
          <li @click="goto('/jnt/center/creat')">
            <i class="iconfont" style="font-size:2.3rem;">&#xe852;</i><br />创建的纪念馆
          </li>
        </ul>
        <ul>
          <li @click="goto('/jnt/center/friend')">
            <i class="iconfont" style="font-size:2.4rem;">&#xe60e;</i><br />亲友团的馆
          </li>
        </ul>
        <ul>
          <li @click="goto('/jnt/center/collect')">
            <i class="iconfont" style="font-size:2.8rem;">&#xe620;</i><br />我关注的馆
          </li>
        </ul>
        <ul>
          <li @click="goto('/jnt/center/msg')">
            <i class="iconfont" style="font-size:2.6rem;">&#xe744;</i><br />我的留言
          </li>
        </ul>

        <ul>
          <li @click="goto('/jnt/help')">
            <i class="iconfont" style="font-size:2.3rem;">&#xe738;</i><br />帮助反馈
          </li>
        </ul>
        <ul>
          <li @click="goto('/jnt/center/about')">
            <i class="iconfont" style="font-size:2.4rem;">&#xe633;</i><br />关于嘉盛云
          </li>
        </ul>
        <ul>
          <li @click="goto('/jnt/center/setting')">
            <i class="iconfont" style="font-size:2.4rem;">&#xe892;</i><br />设置
          </li>
        </ul>
        <ul>
          <li @click="show = true">
            <i class="iconfont" style="font-size:2.8rem;">&#xe621;</i><br />联系客服
          </li>
        </ul>

        <!-- <ul>
          <li><i class="iconfont" style="font-size:2.8rem;">&#xe61f;</i><br />优惠券</li>
        </ul> -->
      </div>
    </div>
    <!-- <div class="contentDiv" style="height: 8rem; margin-top:3rem;">
      <div class="menu">
        
      </div>
    </div> -->
    <van-action-sheet v-model="show" title="联系客服">
      <div class="content">0546-75889977</div>
    </van-action-sheet>
    <!-- <div class="sg1">
      <a href="/shop/tsjysub">
        <div class="context1">投诉建议</div>
        <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
      </a>
    </div>
    <div class="sg1" @click="tel = true">
      <div class="context1">客服电话</div>
      <span class="dianhua"><i class="iconfont">&#xe678;</i></span>
    </div>
    <div class="phone" v-if="tel" @click="tel = false">
      <div class="bg1"></div>
      <div class="login1">
        <ul>
          <a href="tel:0546-75889977"
            ><li>
              咨询热线&nbsp;:&nbsp;<span style="color: rgb(21, 168, 146);">0546-75889977</span>
            </li></a
          >
          
        </ul>
      </div>
    </div> -->
    <div style="height: 1rem;"></div>
    <div class="clear-foot"></div>
  </div>
</template>

<script>
export default {
  name: 'my',
  data() {
    return {
      tel: false,
      show: false,
    }
  },
  created() {},
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
  },
}
</script>

<style>
.userCenter {
  background-color: #f5f5f5;
  overflow: hidden;
  height: 66.7rem;
  overflow: auto;
}
.userCenter .head {
  height: 20rem;
  background-color: #129889;
}
.userCenter .set {
  position: absolute;
  width: 2rem;
  height: 2rem;
  top: 0;
  right: 0;
  z-index: 99999999;
}
.userCenter .head .img {
  margin: 2.5rem;
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
}
.userCenter .head .nick {
  position: relative;
  bottom: 2rem;
  color: #fff;
  text-align: center;
  font-size: 1.6rem;
}
.userCenter .navList {
  height: 7.6rem;
  margin: 2rem;
  margin-top: -4rem;
  padding-top: 1.7rem;
  background-color: #fff;
}
.userCenter .navList ul li {
  height: 6.2rem;
  width: 24%;
  list-style: none;
  float: left;
  text-align: center;
  line-height: 2rem;
  font-size: 1.4rem;
}
.userCenter .menu i,
.userCenter .navList i {
  font-size: 2.8rem;
}
.userCenter .contentDiv {
  height: 30rem;
  margin: 10rem 1rem 0;
  background-color: #fff;
  margin-top: -6rem;
  height: 31.1rem;
  border-radius: 15px;
}
.userCenter .contentDiv .order {
  width: 100%;
  height: 2.6rem;
  padding-left: 1.5rem;
  padding-top: 1.5rem;
  font-size: 1.6rem;
}
.userCenter .contentDiv .menu {
  padding-top: 2.5rem;
}
.userCenter .contentDiv .menu ul {
  margin: 0 !important;
}
.userCenter .contentDiv .menu ul li {
  height: 7.6rem;
  width: 25%;
  list-style: none;
  float: left;
  text-align: center;
  line-height: 2.5rem;
  font-size: 1.2rem;
}
.userCenter .b8 {
  height: 2.277rem;
  width: 2rem;
}
.userCenter .contentDiv .menu ul li {
  height: 7.6rem;
  width: 25%;
  list-style: none;
  float: left;
  text-align: center;
  line-height: 2.5rem;
  font-size: 1.2rem;
}
.userCenter .sg1 {
  height: 5.5rem;
  background-color: #fff;
  margin: 1rem 1rem 0;
  padding-top: 1.6rem;
  font-size: 1.6rem;
  position: relative;
}
.userCenter .jiantou {
  position: absolute;
  right: 1rem;
  top: 2.2rem;
}
.userCenter .dianhua {
  position: absolute;
  right: 1rem;
  top: 2.2rem;
}
.userCenter .sg1 .context1 {
  position: relative;
  left: 1rem;
}
.userCenter .sg1 .page11 {
  width: auto;
  height: 1.415rem;
  float: right;
  position: relative;
  right: 1rem;
  top: -1.5rem;
}
.userCenter .sg1 .page11 {
  width: auto;
  height: 1.415rem;
  float: right;
  position: relative;
  right: 1rem;
  top: -1.5rem;
}
.userCenter .phone {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  overflow: hidden;
}
.userCenter .phone .bg1 {
  position: absolute;
  width: 100%;
  height: 100%;
}
.userCenter .login1 {
  left: 15%;
  top: 40%;
  width: 70%;
  border-radius: 0.5rem;
  padding: 0 1.7rem;
  background-color: #fff;
  position: absolute;
}
.userCenter .login1 ul {
  margin: 0 auto;
}
.userCenter .login1 ul li {
  height: 5.5rem;
  line-height: 5.9rem;
  font-size: 1.6rem;
  text-align: center;
  border-bottom: 0.1rem solid #eee;
}
.userCenter .content {
  color: rgb(177, 109, 78);
  position: relative;
  padding: 0;
  text-align: center;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 4.2rem;
  display: flex;
}
</style>
